import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section`
    width: inherit;
    overflow: hidden;
    padding: 0.5rem 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const InnerContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(9rem, 10.75rem));
    gap: 1rem;
    margin-top: 1rem;
    padding: 0 1rem 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 0 1rem 0;
    }
`

export const LinkCard = styled.a`
    display: flex;
    flex-direction: column;
    width: 100%;
    text-decoration: none;
    cursor: pointer;

    &:hover img {
        transform: scale(1.08);
    }
`

export const ImageWrapper = styled.div`
    width: 100%;
    aspect-ratio: 4 / 3;
    border-radius: 1rem;
    overflow: hidden;
    background-color: #e0e0e0;

    img {
        transition: transform 0.3s ease;
    }
`

export const LinkLabel = styled.span`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.5rem;
    color: #282828;
    margin-top: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1rem;
    }
`
